<template>
	<div v-loading="loading">
		<div class="app-container">
			<div class="el-title">双随机检查信息</div>
			<el-table v-loading="loading" border :data="ssjJcxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
			    <el-table-column label="任务名称" align="center" prop="rwmc" />
				 <el-table-column label="任务发起部门" align="center" prop="rwFqbmname" />				
				<el-table-column label="抽查时间" align="center" prop="ccsjq" >
					<template slot-scope="scope">
							自{{ parseTime(scope.row.ccsjq, '{y}-{m}-{d}') }}至{{ parseTime(scope.row.ccsjz, '{y}-{m}-{d}') }}
						</template>
				</el-table-column>
				<el-table-column label="检查事项" align="center" prop="cjdl" >	
				 <template slot-scope="scope">
				 			自{{scope.row.cjdl}}-{{ scope.row.cjxl}}
				 		</template>
				</el-table-column>
				<el-table-column label="检查结果" align="center" prop="jcjg" >
				 <template slot-scope="scope">
				 			{{selectDictLabel(ssjjcjgOptions,scope.row.jcjg)}}
				 		</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalSsjJcxx>0" :total="totalSsjJcxx" :page.sync="querySsjJcxxParams.pageNum"
				:limit.sync="querySsjJcxxParams.pageSize" @pagination="getSsjJcxxList()()" />
			<div class="el-title">食品生产企业检查信息</div>
			<el-table v-loading="loading" border :data="spscJcxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="监督监测环节" align="center" prop="checkstep" />
				<el-table-column label="注册地址" align="center" prop="dom" width="220" />
				<el-table-column label="生产(经营)地址" align="center" prop="oploc" width="220" />
				<el-table-column label="检查时间" align="center" prop="checkfrom">
					<template slot-scope="scope">
						自{{ parseTime(scope.row.checkfrom, '{y}-{m}-{d}') }}至{{ parseTime(scope.row.checkto, '{y}-{m}-{d}') }}
					</template>
				</el-table-column>
				<el-table-column label="检查结果" align="center" prop="checkresult" />
				<el-table-column label="处理方式" align="center" prop="checkopin" />
			</el-table>
			<pagination v-show="totalspscJcxx>0" :total="totalspscJcxx" :page.sync="querySpscJcxxParams.pageNum"
				:limit.sync="querySpscJcxxParams.pageSize" @pagination="geSpscqyJcxxList()" />
			<div class="el-title">药品检查项目信息</div>
			<el-table v-loading="loading" border :data="ypJcxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="检查计划" align="center" prop="jcjhName" />
				<el-table-column label="条款内容" align="center" prop="tknr" />
				<el-table-column label="检查时间" align="center" prop="checkfrom">
					<template slot-scope="scope">
						自{{ parseTime(scope.row.rqJcks, '{y}-{m}-{d}') }}至{{ parseTime(scope.row.rqJcjs, '{y}-{m}-{d}') }}
					</template>
				</el-table-column>
				<el-table-column label="检查结果" align="center" prop="jcjl" />
				<el-table-column label="结论" align="center" prop="jl" />
			</el-table>
			<pagination v-show="totalYpJcxx>0" :total="totalYpJcxx" :page.sync="queryYpJcxxParams.pageNum"
				:limit.sync="queryYpJcxxParams.pageSize" @pagination="geYpJcxxList()" />
			<div class="el-title">药品抽检信息</div>
			<el-table v-loading="loading" border :data="ypCjxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="抽样任务" align="center" prop="cyRwlynr" width="220">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="提示:点击查看药品抽检详情" placement="bottom">
							<el-button type="text" @click="handleDetailYpcjxx(scope.row)">
								{{scope.row.cyRwlynr }}
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="抽样单位" align="center" prop="cyCydwmc" />
				<el-table-column label="被抽样单位" align="center" prop="cyBcydwmc" />
				<el-table-column label="抽样生产单位" align="center" prop="cyScdwmc" />
				<el-table-column label="抽样日期" align="center" prop="cyRqCy" />
				<el-table-column label="抽样药品通用名" align="center" prop="cyYpmc" />
				<el-table-column label="抽样批号" align="center" prop="cyPh" />
				<el-table-column label="项目检验结论" align="center" prop="xmXmjyjl22989" />

			</el-table>
			<pagination v-show="totalYpCjxx>0" :total="totalYpCjxx" :page.sync="queryYpCjxxParams.pageNum"
				:limit.sync="queryYpCjxxParams.pageSize" @pagination="geYpCjxxList()" />
			<el-dialog title="药品抽检信息详情" :visible.sync="detailYpcjxxopen " width="60%" append-to-body
				:close-on-click-modal="false">
				<Ypcjxx :ypcjxx="ypcjxx"></Ypcjxx>
				<div slot="footer" class="dialog-footer" style="text-align: center;position:sticky">
					<el-button @click="detailYpcjxxopen = false">关 闭</el-button>
				</div>
			</el-dialog>
			<div class="el-title">食品抽检信息</div>
			<el-table v-loading="loading" border :data="spCjxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="被抽样单位" align="center" prop="cyJgmcBcydw" width="260">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="提示:点击查看食品抽检详情" placement="bottom">
							<el-button type="text" @click="handleDetailSpcjxx(scope.row)">
								{{scope.row.cyJgmcBcydw }}
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="抽样时间" align="center" prop="cyCysj" />
				<el-table-column label="样品名称" align="center" prop="cyYpmc" />
				<el-table-column label="检验项目" align="center" prop="xmJyxmmc" />
				<el-table-column label="检验结果" align="center" prop="xmJyxmjg" />
				<el-table-column label="抽样单位" align="center" prop="cyDwmc" />
			</el-table>
			<pagination v-show="totalSpCjxx>0" :total="totalSpCjxx" :page.sync="querySpCjxxParams.pageNum"
				:limit.sync="querySpCjxxParams.pageSize" @pagination="geSpCjxxList()" />
			<el-dialog title="食品抽检信息详情" :visible.sync="detailSpcjxxopen " width="60%" append-to-body
				:close-on-click-modal="false">
				<Spcjxx :spcjxx="spcjxx"></Spcjxx>
				<div slot="footer" class="dialog-footer" style="text-align: center;position:sticky">
					<el-button @click="detailSpcjxxopen = false">关 闭</el-button>
				</div>
			</el-dialog>
			<div class="el-title">质检检验检测报告信息</div>
			<el-table v-loading="loading" border :data="zjJcxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="受检单位" align="center" prop="sjdw" width="260">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="提示:点击查看质检检验检测报告详情" placement="bottom">
							<el-button type="text" @click="handleDetailZjjcxx(scope.row)">
								{{ (scope.row.sjdw.split(/[0,1,2,3,4,5,6,7,8,9]/))[0] }}
							</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="产品名称" align="center" prop="ypmc" />
				<el-table-column label="检验日期" align="center" prop="jyrq" />
				<el-table-column label="规格型号" align="center" prop="ypgg" />
				<el-table-column label="生产单位" align="center" prop="scdw" />
				<el-table-column label="委托单位" align="center" prop="wtdw" />
				<el-table-column label="检验结论" align="center" prop="jyjl" />
			</el-table>
			<pagination v-show="totalZjjcxx>0" :total="totalZjjcxx" :page.sync="queryZjJcxxParams.pageNum"
				:limit.sync="queryZjJcxxParams.pageSize" @pagination="getZjJcxxxxList()" />
			<el-dialog title="质监检验检测报告详情" :visible.sync="detailZjjcxxopen " width="60%" append-to-body
				:close-on-click-modal="false">
				<Zjjcxx :zjjcxx="zjjcxx"></Zjjcxx>
				<div slot="footer" class="dialog-footer" style="text-align: center;position:sticky">
					<el-button @click="detailZjjcxxopen = false">关 闭</el-button>
				</div>
			</el-dialog>
			<div class="el-title">特种设备基本信息</div>
			<el-table v-loading="loading" border :data="tzsbJbxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />	
				<el-table-column label="设备种类" align="center" prop="equipclass" width="200">
			 	<template slot-scope="scope">
			 		<el-tooltip class="item" effect="dark" content="提示:点击查看特种设备详情" placement="bottom">
			 			<el-button type="text" @click="handleDetailTzsbJbxx(scope.row)">
			 				{{ scope.row.equipclass}}
			 			</el-button>
			 		</el-tooltip>
			 	</template>
				</el-table-column>
				<el-table-column label="使用单位" align="center" prop="useorg" />
				<el-table-column label="制造单位" align="center" prop="createorg" />
				<el-table-column label="检验日期" align="center" prop="checkdate" />
				<el-table-column label="下次检验日期" align="center" prop="nextcheckdate" />
				<el-table-column label="检验结论" align="center" prop="checkresult" />
			</el-table>
			<pagination v-show="totalTzsbxx>0" :total="totalTzsbxx" :page.sync="queryTzsbJbxxParams.pageNum"
				:limit.sync="queryTzsbJbxxParams.pageSize" @pagination="getTzsbJbxxList()" />
			<el-dialog title="特种设备基本信息详情" :visible.sync="detailTzsbJbxxopen " width="60%" append-to-body
				:close-on-click-modal="false">
				<TzsbJbxx :tzsbjbxx="tzsbjbxx"></TzsbJbxx>
				<div slot="footer" class="dialog-footer" style="text-align: center;position:sticky">
					<el-button @click="detailTzsbJbxxopen = false">关 闭</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		listSpscJcxx,
		listYpjcxxx,
		listYpcjxxx,
		listSpcjxx,
		listZjjcxx,
		listTzsbJbxx,
		listSsjJcxx
	} from "@/api/qygzs/yqyd";
	import Ypcjxx from "@/views/qygzs/yqyd/qy/ypcjxx/Ypcjxx";
	import Spcjxx from "@/views/qygzs/yqyd/qy/spcjxx/Spcjxx";
	import Zjjcxx from "@/views/qygzs/yqyd/qy/zjjcxx/Zjjcxx";
	import TzsbJbxx from "@/views/qygzs/yqyd/qy/tzsbjbxx/TzsbJbxx";
	
	export default {
		name: 'Jgxx',
		components: {
			Ypcjxx,
			Spcjxx,
			Zjjcxx,
			TzsbJbxx
		},
		props: {
			//企业名称
			entname: {
				type: String,
				require: true
			},
			uniscid: {
				type: String,
				require: false
			}
		},
		watch: {
			entname(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				// 选中数组
				loading:true,
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【食品生产企业检查信息】总条数
				totalspscJcxx: 0,
				// 【食品生产企业检查信息】表格数据				 
				spscJcxxList: [],
				querySpscJcxxParams: {
					pageNum: 1,
					pageSize: 10,
					entname: undefined,
				},
				totalYpJcxx: 0,
				// 【药品检查项目信息列表】表格数据				 
				ypJcxxList: [],
				queryYpJcxxParams: {
					pageNum: 1,
					pageSize: 10,
					qyzwmc: undefined,
				},
				totalYpCjxx: 0,
				// 【药品抽检信息】表格数据				 
				ypCjxxList: [],
				queryYpCjxxParams: {
					pageNum: 1,
					pageSize: 10,
					cyScdwmc: undefined,
					cyBcydwmc: undefined,
				},
				detailYpcjxxopen: false,
				ypcjxx: {},
				totalSpCjxx: 0,
				// 【食品抽检信息】表格数据				 
				spCjxxList: [],
				querySpCjxxParams: {
					pageNum: 1,
					pageSize: 10,
					cyJgmcBcydw: undefined,
				},
				detailSpcjxxopen: false,
				spcjxx: {},
				// 【质检检验检测报告】表格数据
				totalZjjcxx: 0,
				zjJcxxList: [],
				queryZjJcxxParams: {
					pageNum: 1,
					pageSize: 10,
					sjdw: undefined,
				},
				detailZjjcxxopen: false,
				zjjcxx: {},
				// 【特种社保基本信息】表格数据
				totalTzsbxx: 0,
				tzsbJbxxList: [],
				queryTzsbJbxxParams: {
					pageNum: 1,
					pageSize: 10,
					useorg: undefined,
				},
				detailTzsbJbxxopen: false,
				tzsbjbxx: {},
				// 【双随机检查信息】表格数据
				totalSsjJcxx: 0,
				ssjJcxxList: [],
				querySsjJcxxParams: {
					pageNum: 1,
					pageSize: 10,
					qymc: undefined,
					zch: undefined,
				},
				ssjjcjgOptions:[]
			}
		},
		created() {
			this.init();
			this.getDicts("SSJ_JCJG").then(response => {
				this.ssjjcjgOptions = response.data;
			});
		},

		methods: {
			init() {
				this.loading = true;
				this.geSpscqyJcxxList();
				this.geYpJcxxList();
				this.geYpCjxxList();
				this.geSpCjxxList();
				this.getZjJcxxxxList();
				this.getTzsbJbxxList();
				this.getSsjJcxxList() ;
			},

			// 获取食品生产企业检查信息
			geSpscqyJcxxList() {
				this.loading = true;
				this.querySpscJcxxParams.entname = this.entname;
				listSpscJcxx(this.querySpscJcxxParams).then(response => {
					this.spscJcxxList = response.rows;
					this.totalspscJcxx = response.total;
					this.loading = false;
				});
			},
			// 获取药品检查项目信息列表
			geYpJcxxList() {
				this.loading = true;
				this.queryYpJcxxParams.qyzwmc = this.entname;
				listYpjcxxx(this.queryYpJcxxParams).then(response => {
					this.ypJcxxList = response.rows;
					this.totalYpJcxx = response.total;
					this.loading = false;
				});
			},
			// 获取药品抽样检查信息列表
			geYpCjxxList() {
				this.loading = true;
				this.queryYpCjxxParams.cyScdwmc = this.entname;
				this.queryYpCjxxParams.cyBcydwmc = this.entname;
				listYpcjxxx(this.queryYpCjxxParams).then(response => {
					this.ypCjxxList = response.rows;
					this.totalYpCjxx = response.total;
					this.loading = false;
				});
			},
			//药品样品抽检信息详情
			handleDetailYpcjxx(row) {
				this.detailYpcjxxopen = true;
				this.ypcjxx = row;
			},
			// 获取食品抽样检查信息列表
			geSpCjxxList() {
				this.loading = true;
				this.querySpCjxxParams.cyJgmcBcydw = this.entname;
				listSpcjxx(this.querySpCjxxParams).then(response => {
					this.spCjxxList = response.rows;
					this.totalSpCjxx = response.total;
					this.loading = false;
				});
			},
			//食品样品抽检信息详情
			handleDetailSpcjxx(row) {
				this.detailSpcjxxopen = true;
				this.spcjxx = row;
			},
			// 获取质检检验检测信息列表
			getZjJcxxxxList() {
				this.loading = true;
				this.queryZjJcxxParams.sjdw = this.entname;
				listZjjcxx(this.queryZjJcxxParams).then(response => {
					this.zjJcxxList = response.rows;
					this.totalZjjcxx = response.total;
					this.loading = false;
				});
			},
			//获取质检检验检测信息详情
			handleDetailZjjcxx(row) {
				this.detailZjjcxxopen = true;
				this.zjjcxx = row;
			},
			// 获取特种设备基本信息列表
			getTzsbJbxxList() {
				this.loading = true;
				this.queryTzsbJbxxParams.useorg = this.entname;
				listTzsbJbxx(this.queryTzsbJbxxParams).then(response => {							 
					this.tzsbJbxxList = response.rows;
					this.totalTzsbxx = response.total;
					this.loading = false;
				});
			},
			//获取特种设备基本信息详情
			handleDetailTzsbJbxx(row) {
				this.detailTzsbJbxxopen = true;
				this.tzsbjbxx = row;
			},
			// 获取双随机检查信息列表
			getSsjJcxxList() {
				this.loading = true;
				this.querySsjJcxxParams.qymc = this.entname;
				this.querySsjJcxxParams.zcj = this.uniscid;
				listSsjJcxx(this.querySsjJcxxParams).then(response => {							 
					this.ssjJcxxList = response.rows;
					this.totalSsjJcxx = response.total;
					this.loading = false;
				});
			},
			
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
